import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { useRoute } from 'vue-router';
import IndexPage from './SalesmanPoints.vue';
export default {
  name: 'index',

  setup(__props) {
    const route = useRoute();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_unref(route).name === 'SalesmanPoints' ? (_openBlock(), _createBlock(IndexPage, {
        key: "SalesmanPoints",
        integralMode: "1"
      })) : (_openBlock(), _createBlock(IndexPage, {
        integralMode: "2",
        key: "PlatformPoints"
      }))]);
    };
  }

};